import React from "react";

interface IPortfoTableSectionProps {
  title: string;
  className?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}

const PortfoTableSection = ({
  title,
  className = "",
  action,
  children,
}: IPortfoTableSectionProps) => {
  return (
    <div
      className={`flex w-full flex-col justify-start items-stretch text-right ${className}`}
    >
      <div className="flex w-full items-center justify-between px-3 text-right text-sm font-bold whitespace-nowrap py-0">
        <span>{title}</span>
        {action}
      </div>
      {children}
    </div>
  );
};

export default PortfoTableSection;
